module.exports = __webpack_public_path__ + "Simple-Line-Icons.f33df365d6d0255b586f.eot";


//////////////////
// WEBPACK FOOTER
// /rightcompound/angular/node_modules/simple-line-icons/fonts/Simple-Line-Icons.eot?v=2.4.0
// module id = ../../../../simple-line-icons/fonts/Simple-Line-Icons.eot?v=2.4.0
// module chunks = styles